import { render, staticRenderFns } from "./sellDetail.vue?vue&type=template&id=67fa28ca&scoped=true"
import script from "./sellDetail.vue?vue&type=script&lang=js"
export * from "./sellDetail.vue?vue&type=script&lang=js"
import style0 from "./sellDetail.vue?vue&type=style&index=0&id=67fa28ca&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fa28ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fa28ca')) {
      api.createRecord('67fa28ca', component.options)
    } else {
      api.reload('67fa28ca', component.options)
    }
    module.hot.accept("./sellDetail.vue?vue&type=template&id=67fa28ca&scoped=true", function () {
      api.rerender('67fa28ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cooperationMall/newCooperationMall/detail/sellDetail.vue"
export default component.exports